<template lang="pug">
  //- Тот же значок, что у комментариев к задачам (NotificationCommentPublish)
  Icon.icon(name="notification-comment" v-if="type === 'icon'")
  //- автор в тексте не нужен: список уведомлений сам показывает item.initiator
  div(v-else-if="type === 'title'") Добавлен комментарий к заявке
    //- компания или воронка могут быть удалены к моменту показа — тогда
    //- ссылку построить не из чего и остаётся одно название
    Link(v-if="leadRoute" :to="leadRoute")  {{ item.info.leadTitle }}
    span(v-else)  {{ item.info.leadTitle }}
    template(v-if="item.info.funnelName")
      |  в воронке {{ item.info.funnelName }}
</template>

<script>
export default {
  name: 'NotificationCrmLeadCommentPublish',
  props: {
    item: Object,
    type: String,
  },
  computed: {
    leadRoute() {
      const { companyId, funnelId, leadId } = this.item.info;
      if (!companyId || !funnelId || !leadId) return null;

      return { name: 'crm-lead', params: { companyId, funnelId, leadId } };
    },
  },
};
</script>
